// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_Billing360OverviewRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_Billing360OverviewRow — one franchise summary row for GET /subscriptions/admin/billing-360-overview.
 */
import { registerContract } from './validate'

export interface Subscriptions_Billing360OverviewRow {
franchise_id: number
franchise_name?: string
subscription_status?: string
subscription_plan_name?: string
subscription_provider?: string
subscription_currency?: string
subscription_price_cents?: number
grace_status?: string
grace_until?: string
credits_balance_micro?: number
credits_reserved_micro?: number
setup_fee_status?: string
setup_fee_amount_cents?: number
setup_fee_currency?: string
setup_fee_charge_status?: string
}

registerContract('Subscriptions_Billing360OverviewRow', {
  franchise_id:             { type: 'number',  required: true },
  franchise_name:           { type: 'string',  required: false },
  subscription_status:      { type: 'string',  required: false },
  subscription_plan_name:   { type: 'string',  required: false },
  subscription_provider:    { type: 'string',  required: false },
  subscription_currency:    { type: 'string',  required: false },
  subscription_price_cents: { type: 'number',  required: false },
  grace_status:             { type: 'string',  required: false },
  grace_until:              { type: 'string',  required: false },
  credits_balance_micro:    { type: 'number',  required: false },
  credits_reserved_micro:   { type: 'number',  required: false },
  setup_fee_status:         { type: 'string',  required: false },
  setup_fee_amount_cents:   { type: 'number',  required: false },
  setup_fee_currency:       { type: 'string',  required: false },
  setup_fee_charge_status:  { type: 'string',  required: false },
})
